import { Box } from "@material-ui/core";
import useNenhumaDespesaEncontradaGroupPayStyles from "./styles/NenhumaDespesaEncontradaGroupPayStyles";
import { FaClock } from "react-icons/fa";

const NenhumaDespesaEncontradaGroupPay = () => {
  const styles = useNenhumaDespesaEncontradaGroupPayStyles();

  return (
    <Box className={styles.container}>
      <Box className={styles.iconContainer}>
        <FaClock className={styles.icon} />
      </Box>

      <Box>
        <h3 className={styles.title}>Ainda não há despesas captadas</h3>
        <p className={styles.subtitle}>
          Verifique se os condomínios estão configurados corretamente e aguarde. Nossa IA está trabalhando para buscar
          as despesas automaticamente.
        </p>
      </Box>
    </Box>
  );
};

export default NenhumaDespesaEncontradaGroupPay;
